import vue from '@/main'
import socket from '../client'

socket.on('newMessage', () => {
  vue.$store.dispatch('UPDATE_NOTIFICATIONS')
})
